import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ProfilePage.css";
import ProgressLoader from "../Loader/ProgressLoader";

const ProfilePage = () => {
  const [userData, setUserData] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    mobile: "",
    fullAddress: "",
    landmark: "",
    pincode: ""
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(()=>{
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 1500);
      return () => clearTimeout(timer);
    }
  },[message])

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const user = JSON.parse(sessionStorage.getItem("user"));
        if (!user || !user.email) {
          setMessage({ type: "error", text: "User not logged in" });
          setLoading(false);
          return;
        }

        const response = await axios.get(
          "https://api.dremerz.net/api/Kalanjiyam_Users_Registration"
        );
        const users = response.data;
        const currentUser = users.find(us => us.email === user.email);
        
        if (!currentUser) {
          setMessage({ type: "error", text: "User not found" });
          setLoading(false);
          return;
        }
        
        setUserId(currentUser.id);
        setUserData(currentUser);
        setFormData({
          fullname: currentUser.fullname || "",
          email: currentUser.email || "",
          mobile: currentUser.mobile || "",
          fullAddress: currentUser.fullAddress || "",
          landmark: currentUser.landmark || "",
          pincode: currentUser.pincode || ""
        });
        
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setMessage({ type: "error", text: "Failed to fetch user data" });
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleProfileSubmit = async (e) => {
  e.preventDefault();

  try {
    setActionLoading(true);  // ← show loader
    await axios.put(
      `https://api.dremerz.net/api/Kalanjiyam_Users_Registration/${userId}`,
      { 
        fullname: formData.fullname,
        fullAddress: formData.fullAddress,
        landmark: formData.landmark,
        pincode: formData.pincode
      }
    );

    setTimeout(() => {
      setUserData(prev => ({ ...prev, ...formData }));
      setMessage({ type: "success", text: "Profile updated successfully" });
      setEditMode(false);
      setActionLoading(false); // ← hide loader
    }, 800);
  } catch (error) {
    console.error("Error updating profile:", error);
    setMessage({ type: "error", text: "Failed to update profile" });
    setActionLoading(false); // ← hide loader on error
  }
};


const handlePasswordSubmit = async (e) => {
  e.preventDefault();
  
  if (passwordData.newPassword !== passwordData.confirmPassword) {
    setMessage({ type: "error", text: "New passwords do not match" });
    return;
  }

  try {
    setActionLoading(true); // ← show loader
    await axios.put(
      `https://api.dremerz.net/api/Kalanjiyam_Users_Registration/${userId}`,
      { 
        password: passwordData.newPassword
      }
    );

    setTimeout(() => {
      setMessage({ type: "success", text: "Password updated successfully" });
      setShowPasswordModal(false);
      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      });
      setActionLoading(false); // ← hide loader
    }, 800);
  } catch (error) {
    console.error("Error updating password:", error);
    setMessage({ type: "error", text: "Failed to update password" });
    setActionLoading(false); // ← hide loader
  }
};


  if (loading) {
    return (
      <div className="profile-loading-container" style={{minHeight:"65vh"}} >
        <ProgressLoader />
      </div>
    );
  }

  return (
    <>
    {actionLoading ? (
      <div className="text-center global-loader-overlay" style={{minHeight: "65vh"}}>
        <ProgressLoader />
      </div>
    ):(

      <div className="profile-ecom-wrapper">

        {/* HEADER */}
        <div className="profile-ecom-header d-none d-md-flex align-items-center justify-content-center flex-column">
          <div className="profile-ecom-avatar">
            <i className="fas fa-user"></i>
          </div>
          <h2 className="profile-ecom-title">My Account</h2>
          {/* <p className="profile-ecom-sub">{userData?.email}</p> */}
        </div>

        {/* CONTENT */}
        <div className="profile-ecom-body">

          {/* VIEW MODE */}
          {!editMode && (
            <>
              <h3 className="section-title">Profile Details</h3>

              <div className="profile-ecom-grid">
                <div className="grid-item">
                  <span className="label">Full Name</span>
                  <p className="value">{userData.fullname || "Not provided"}</p>
                </div>

                <div className="grid-item">
                  <span className="label">Mobile</span>
                  <p className="value">{userData.mobile || "Not provided"}</p>
                </div>

                <div className="grid-item full">
                  <span className="label">Email</span>
                  <p className="value">{userData.email || "Not provided"}</p>
                </div>

                <div className="grid-item full">
                  <span className="label">Full Address</span>
                  <p className="value">{userData.fullAddress || "Not provided"}</p>
                </div>

                <div className="grid-item">
                  <span className="label">Landmark</span>
                  <p className="value">{userData.landmark || "Not provided"}</p>
                </div>

                <div className="grid-item">
                  <span className="label">Pincode</span>
                  <p className="value">{userData.pincode || "Not provided"}</p>
                </div>
              </div>

              <div className="profile-ecom-actions">
                <button className="btn-ecom-primary" onClick={() => setEditMode(true)}>
                  <i className="fas fa-edit me-2"></i>
                  Edit Profile
                </button>
                <button className="btn-ecom-secondary" onClick={() => setShowPasswordModal(true)}>
                  <i className="fas fa-key me-2"></i>
                  Change Password
                </button>
              </div>
            </>
          )}

          {/* EDIT MODE */}
          {editMode && (
            <>
              <h3 className="section-title">Edit Profile</h3>

              <form className="profile-ecom-form" onSubmit={handleProfileSubmit}>
                <div className="form-group-ecom">
                  <label>Full Name</label>
                  <input type="text" name="fullname" value={formData.fullname} onChange={handleInputChange} required />
                </div>

                <div className="form-group-ecom">
                  <label>Email</label>
                  <input type="email" value={formData.email} disabled />
                </div>

                <div className="form-group-ecom">
                  <label>Mobile</label>
                  <input type="text" value={formData.mobile} disabled />
                </div>

                <div className="form-group-ecom">
                  <label>Full Address</label>
                  <textarea name="fullAddress" value={formData.fullAddress} onChange={handleInputChange}></textarea>
                </div>

                <div className="form-row-ecom">
                  <div className="form-group-ecom">
                    <label>Landmark</label>
                    <input type="text" name="landmark" value={formData.landmark} onChange={handleInputChange} />
                  </div>

                  <div className="form-group-ecom">
                    <label>Pincode</label>
                    <input type="text" name="pincode" value={formData.pincode} onChange={handleInputChange} />
                  </div>
                </div>

                <div className="profile-ecom-actions">
                  <button className="btn-ecom-primary" type="submit">
                    Save Changes
                  </button>
                  <button className="btn-ecom-secondary" type="button" onClick={() => setEditMode(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    )}
      {/* PASSWORD MODAL */}
      {showPasswordModal && (
        <div className="profile-modal-overlay">
          <div className="profile-modal">
            <h3>Update Password</h3>

            <form onSubmit={handlePasswordSubmit}>
              <div className="form-group-ecom">
                <label>Current Password</label>
                <input type="password" name="currentPassword" value={passwordData.currentPassword} onChange={handlePasswordChange} />
              </div>
              <div className="form-group-ecom">
                <label>New Password</label>
                <input type="password" name="newPassword" value={passwordData.newPassword} onChange={handlePasswordChange} />
              </div>
              <div className="form-group-ecom">
                <label>Confirm New Password</label>
                <input type="password" name="confirmPassword" value={passwordData.confirmPassword} onChange={handlePasswordChange} />
              </div>

              <div className="profile-ecom-actions">
                <button className="btn-ecom-secondary" type="button" onClick={() => setShowPasswordModal(false)}>
                  Cancel
                </button>
                <button className="btn-ecom-primary" type="submit">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MESSAGE MODAL */}
      {message.text && (
        <div className="profile-modal-overlay">
          <div className="profile-modal">
            <h3>{message.type === "error" ? "Error" : "Success"}</h3>
            <p>{message.text}</p>
            <button className="btn-ecom-primary" onClick={() => setMessage({ type: "", text: "" })}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );


};

export default ProfilePage;